import { Label } from 'office-ui-fabric-react';
import { TagPicker } from 'office-ui-fabric-react/lib/Pickers';
import React, { Component } from 'react';
import { DataSociete } from '../../data/DataSociete';
import { Immocom } from '../../specifique/immocom';

/*
******************************************************************************************************
PROPS :
    ATTRIBUTS :
        bool?   disabled
        string? label
        bool?   required
        int     selectedKey                 idSociete de la société sélectionnée
    METHODES :
        void    onChange(societe)           méthode appelée à la (dé)sélection d'une société
******************************************************************************************************
*/

export class PickerSociete extends Component {

    static defaultProps = {
        disabled: false,
        label: "Société",
        onChange: (societe) => console.log(societe),
        required: false,
    };

    constructor(props) {
        super(props);
        this._societes = [];
        this.state = { items: [] };
    };

    _chargementDonnees = () => {
        this.setState({ enCoursDeTraitement: true });
        let chargementSocietes = DataSociete._chargementSocietes({}, "nom", false);
        chargementSocietes
            .then(responseFetch => {
                const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                if (retourVerif === null) {
                    this._societes = responseFetch.reponseAPIobjet || [];
                    const items = this._societes.map(societe => ({ key: societe.idSociete, name: societe.nom }));
                    const stateTemp = { items };
                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);
                }
                else {
                    this._societes = [];
                    this.setState({ items: [] });
                    Immocom.onTraitementErreurPromise(this, retourVerif);
                }
            });
    };

    _getSelectedItemsFromProps = () => {
        const { selectedKey } = this.props;
        const { items } = this.state;
        const selectedItem = selectedKey && items.find(item => item.key === selectedKey);
        return selectedItem ? [selectedItem] : []
    };

    _onResolveSuggestions = (filterText, tagList) => {
        const { items } = this.state;
        return filterText ? items.filter(item => item.name.toLowerCase().indexOf(filterText.toLowerCase()) === 0) : [];
    };

    _onChange = (selection) => {
        const idSociete = selection.length ? selection[0].key : null;
        const societe = this._societes.find(societe => societe.idSociete === idSociete) || {};
        this.props.onChange(societe);
    };

    componentDidMount = () => {
        this._chargementDonnees();
    };

    render = () => {
        const { disabled, label, required } = this.props;
        const { enCoursDeTraitement } = this.state;
        return <div>
            <Label required={required}>{label}</Label>
            <TagPicker
                //className={(errorMessage ? "champObligatoire_Picker" : "")}
                disabled={enCoursDeTraitement || disabled}
                itemLimit={1}
                onChange={this._onChange}
                onResolveSuggestions={this._onResolveSuggestions}
                pickerSuggestionsProps={{
                    noResultsFoundText: "Aucune société ne correspond à la recherche",
                }}
                selectedItems={this._getSelectedItemsFromProps()}
            />
        </div>;
    };
}